<template>
  <div class="map-input-item">
    <el-input v-model="item.key"></el-input>
    <el-input v-model="item.value"></el-input>
    <el-button
      class="el-icon-remove-outline"
      type="text"
      :disabled="disabledRemove"
      style="font-size: 20px;padding:10px 0;"
      @click="$emit('remove')"
    ></el-button>
    <el-button
      class="el-icon-circle-plus-outline"
      type="text"
      style="font-size: 20px;padding:10px 0;"
      @click="$emit('add')"
    ></el-button>
  </div>
</template>

<script>
export default {
  name: "map-input-item",
  props: {
    item: Object,
    disabledRemove: Boolean
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.map-input-item {
  margin-top: 10px;
  display: flex;
  .el-input {
    margin-right: 10px;
  }
}
</style>
